import React from 'react';

const CardPart = props => {
  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  return (
    <>
      <div
        className={`w-full xl:w-half-auto pt-30 h-auto md:h-352 shadow-card ${props.isPurple ? 'bg-gray-card' : 'bg-white'} rounded-5 pl-22 mb-30 pr-22 ${'order-' + props.order} md:order-none`}
      >
        <div className="min-h-178 fill-current md:h-234 flex flex-wrap flex-col md:flex-row w-full relative">
          <div className="w-full md:w-60p">
            <h3
              className={`uppercase text-24 leading-29 text-black  font-real-bold ${props.isPurple ? 'text-black' : 'text-green-badge'} ${props.whitespace ? 'whitespace-normal md:whitespace-nowrap' : ''} `}
            >
              {props.title}
            </h3>
            {props.checkItems &&
              props.checkItems.map((c, i) => {
                return (
                  <div
                    key={uuidv4()}
                    className={`flex ${i == 0 ? (props.haveMoreItems ? 'mt-5' : 'mt-13') : props.haveMoreItems ? '' : 'mt-5'} text-15 text-black capitalize ${props.haveMoreItems ? 'leading-20' : 'leading-15'} justify-start items-center`}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-25 w-24 mr-10" fill="none" viewBox="0 0 24 24" stroke={`${props.color}`}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    {c.title}
                  </div>
                );
              })}
          </div>
          <div className=" w-full md:w-40p mt-20 relative md:absolute right-0 bottom-0 text-center md:text-right">
            <picture className={'inline-block '}>
              <source media="(min-width:768px)" srcSet={props.webp} type="image/webp" />
              <source media="(min-width:768px)" srcSet={props.image} type="image/png" />
              <source media="(max-width:768px)" srcSet={props.mobile} type="image/png" />
              <img width={props.width} height={props.height} src="" alt={'personage'} className={'object-right'} />
            </picture>
          </div>
        </div>
        <button
          className={`w-full mt-5 mb-20 h-56 rounded-5 ${props.isPurple ? 'bg-purple ' : 'bg-green-badge'} text-white text-18 leading-22 capitalise font-normal`}
          onClick={props.getProposal}
        >
          {props.buttonText}
        </button>
      </div>
    </>
  );
};
export default CardPart;
